import { useCallback } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { Inputs } from '../../../../containers/facilityReservationForm/facilityReservationFormService';
import { PostDecodeMstDto } from '../../../../dataAccess/webApi/dto/decodeMstDto';
import SelectBoxField from "./common/selectBoxField";
import { GItem } from "../../../components/common/grids";
import ConsentCheckField from "./common/consentCheckField";
import { translate } from '../../../../i18n'

export interface ReductionTypeFieldProps {
    childNum: number
    required: boolean
    useConsent: boolean
    options?: PostDecodeMstDto[]
    note: string | null
    consentNote?: string | null
    control: Control<Inputs>
}

const ReductionTypeField = (props: ReductionTypeFieldProps) => {
    const { childNum, required, useConsent, options, note, consentNote, control } = props;

    const inputWatch = useWatch({ name: `children.${childNum}.reductionType.reduction.select`, control: control })

    const showConsent = useCallback(() => {
        return inputWatch && inputWatch !== '';
    },[inputWatch]);

    return (
        <SelectBoxField 
            title={"facilityReservationForm.form.label.reductionType.reduction"}
            name={`children.${childNum}.reductionType.reduction`}
            selectLabel={"facilityReservationForm.form.label.reductionType.reduction"}
            required={required}
            control={control}
            options={options}
            addUnselected
        >
            <GItem xs={12} mb={useConsent? 1: 0} sx={{ whiteSpace: 'pre-line' }}>
                {note}
            </GItem>
            {
                (useConsent && showConsent()) &&(
                    <ConsentCheckField 
                        checkNote={consentNote?? ''}
                        name={`children.${childNum}.reductionType.consentCheck`}
                        label={translate('facilityReservationForm.form.label.reductionType.consentCheck')}
                        control={control}
                    />
                )
            }
        </SelectBoxField>
    )
}

export default ReductionTypeField;

